var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import { fetchEquipmentByExternalEquipmentReference } from '../../adapters/EquipmentAdapter';
import { vehicleSearch, customerSearch, communicationSearch, getCommunicatorByExternalEquipmentReference, getCustomerByEquipmentReference, getCustomerByCustomerReference } from '../../adapters/UniversalSearchAdapter';
var initialState = {
    prefix: '',
    vehicleList: null,
    customerList: null,
    communicationList: null,
    selectedVehicle: null,
    selectedCustomer: null,
    selectedCommunicator: null,
    vehiclesApiLoading: false,
    customerApiLoading: false,
    communicatorApiLoading: false,
    isEquipmentApisLoading: false
};
// Slice
var slice = createSlice({
    name: 'universalSearch',
    initialState: initialState,
    reducers: {
        updatePrefixSuccess: function (state, action) {
            state.prefix = action.payload;
        },
        updateVehicleListSuccess: function (state, action) {
            state.vehicleList = action.payload;
        },
        updateCustomerListSuccess: function (state, action) {
            state.customerList = action.payload;
        },
        updateCommunicationListSuccess: function (state, action) {
            state.communicationList = action.payload;
        },
        updateVehiclesApiLoading: function (state, action) {
            state.vehiclesApiLoading = action.payload;
        },
        updateCustomerApiLoading: function (state, action) {
            state.customerApiLoading = action.payload;
        },
        updateCommunicatorApiLoading: function (state, action) {
            state.communicatorApiLoading = action.payload;
        },
        updateLoading: function (state, action) {
            state = __assign(__assign({}, state), { vehiclesApiLoading: action.payload, customerApiLoading: action.payload, communicatorApiLoading: action.payload });
        },
        selectedSearch: function (state, action) {
            if (action.payload.vehicle)
                state.selectedVehicle = action.payload.vehicle;
            else if (action.payload.customer)
                state.selectedCustomer = action.payload.customer;
            else if (action.payload.communicator)
                state.selectedCommunicator = action.payload.communicator;
        },
        storeCommunicator: function (state, action) {
            state.selectedCommunicator = action.payload;
        },
        storeCustomer: function (state, action) {
            state.selectedCustomer = action.payload;
        },
        updateisEquipmentApisLoading: function (state, action) {
            state.isEquipmentApisLoading = action.payload;
        }
    },
});
export default slice.reducer;
// Actions
var _a = slice.actions, updatePrefixSuccess = _a.updatePrefixSuccess, updateVehicleListSuccess = _a.updateVehicleListSuccess, updateCustomerListSuccess = _a.updateCustomerListSuccess, updateCommunicationListSuccess = _a.updateCommunicationListSuccess, updateVehiclesApiLoading = _a.updateVehiclesApiLoading, updateCustomerApiLoading = _a.updateCustomerApiLoading, updateCommunicatorApiLoading = _a.updateCommunicatorApiLoading, updateLoading = _a.updateLoading, selectedSearch = _a.selectedSearch, storeCommunicator = _a.storeCommunicator, storeCustomer = _a.storeCustomer, updateisEquipmentApisLoading = _a.updateisEquipmentApisLoading;
export var updateprefix = function (value) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch(updatePrefixSuccess(value));
        }
        catch (e) {
            return [2 /*return*/, console.error(e)];
        }
        return [2 /*return*/];
    });
}); }; };
export var fetchVehicleList = function (prefix) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var res, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(updateVehiclesApiLoading(true));
                dispatch(updateVehicleListSuccess(null));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, vehicleSearch(prefix)];
            case 2:
                res = _a.sent();
                dispatch(updateVehicleListSuccess(res.data));
                dispatch(updateVehiclesApiLoading(false));
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                return [2 /*return*/, (console.error(e_1), dispatch(updateVehiclesApiLoading(false)))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var fetchCustomerList = function (prefix) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var res, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(updateCustomerApiLoading(true));
                dispatch(updateCustomerListSuccess(null));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, customerSearch(prefix)];
            case 2:
                res = _a.sent();
                dispatch(updateCustomerListSuccess(res.data));
                dispatch(updateCustomerApiLoading(false));
                return [3 /*break*/, 4];
            case 3:
                e_2 = _a.sent();
                return [2 /*return*/, (console.error(e_2), dispatch(updateCustomerApiLoading(false)))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var fetchCommunicationList = function (prefix) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var res, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(updateCommunicatorApiLoading(true));
                dispatch(updateCommunicationListSuccess(null));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, communicationSearch(prefix)];
            case 2:
                res = _a.sent();
                dispatch(updateCommunicationListSuccess(res.data));
                dispatch(updateCommunicatorApiLoading(false));
                return [3 /*break*/, 4];
            case 3:
                e_3 = _a.sent();
                return [2 /*return*/, (console.error(e_3), dispatch(updateCommunicatorApiLoading(false)))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var selectingSearch = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch(selectedSearch(data));
        }
        catch (e) {
            return [2 /*return*/, (console.error(e), dispatch(updateLoading(false)))];
        }
        return [2 /*return*/];
    });
}); }; };
export var fetchCommunicatorInfo = function (externalEquipmentReference) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var res, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(updateCommunicatorApiLoading(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getCommunicatorByExternalEquipmentReference(externalEquipmentReference)];
            case 2:
                res = _a.sent();
                dispatch(storeCommunicator(res.data));
                dispatch(updateCommunicatorApiLoading(false));
                return [3 /*break*/, 4];
            case 3:
                e_4 = _a.sent();
                return [2 /*return*/, (console.error(e_4), dispatch(updateCommunicatorApiLoading(false)))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var fetchCustomerInfo = function (externalCustomerReference) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var customerResponse, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(updateCustomerApiLoading(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getCustomerByCustomerReference(externalCustomerReference)];
            case 2:
                customerResponse = _a.sent();
                dispatch(storeCustomer(customerResponse.data));
                dispatch(selectedSearch({ customer: customerResponse.data }));
                dispatch(updateCustomerApiLoading(false));
                return [3 /*break*/, 4];
            case 3:
                e_5 = _a.sent();
                dispatch(storeCustomer(null));
                return [2 /*return*/, (console.error(e_5), dispatch(updateCustomerApiLoading(false)))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var fetchEquipment = function (externalEquipmentReference) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var equipmentResponse, customerResponse, communicatorResponse, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(updateisEquipmentApisLoading(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetchEquipmentByExternalEquipmentReference(externalEquipmentReference)];
            case 2:
                equipmentResponse = _a.sent();
                dispatch(selectedSearch({ vehicle: equipmentResponse.data }));
                return [4 /*yield*/, getCustomerByEquipmentReference(externalEquipmentReference)];
            case 3:
                customerResponse = _a.sent();
                dispatch(storeCustomer(customerResponse.data));
                return [4 /*yield*/, getCommunicatorByExternalEquipmentReference(externalEquipmentReference)];
            case 4:
                communicatorResponse = _a.sent();
                dispatch(storeCommunicator(communicatorResponse.data));
                dispatch(updateisEquipmentApisLoading(false));
                return [3 /*break*/, 6];
            case 5:
                e_6 = _a.sent();
                dispatch(storeCustomer(null));
                return [2 /*return*/, (console.error(e_6), dispatch(updateisEquipmentApisLoading(false)))];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
export var equipmentSearch = function (identifier) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var equipmentResponse, e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(updateisEquipmentApisLoading(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, vehicleSearch(identifier)
                    //we want to support only exact matches at this point
                ];
            case 2:
                equipmentResponse = _a.sent();
                //we want to support only exact matches at this point
                if (equipmentResponse.data.length === 1)
                    dispatch(fetchEquipment(equipmentResponse.data[0].externalEquipmentReference));
                return [3 /*break*/, 4];
            case 3:
                e_7 = _a.sent();
                return [2 /*return*/, (console.error(e_7), dispatch(updateisEquipmentApisLoading(false)))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
